import { GlBadge, GlDisclosureDropdownItem, GlTooltip } from '@gitlab/ui';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { userPath } from '~/lib/utils/path_helpers/user';
import { s__ } from '~/locale';
import { USER_MENU_TRACKING_DEFAULTS } from '../constants';
export default {
    name: 'UserMenuProfileItem',
    i18n: {
        user: {
            busy: s__('UserProfile|Busy')
        }
    },
    components: {
        GlBadge,
        GlDisclosureDropdownItem,
        GlTooltip
    },
    directives: {
        SafeHtml
    },
    props: {
        user: {
            required: true,
            type: Object
        }
    },
    computed: {
        menuItem () {
            return {
                text: this.user.name,
                href: userPath(this.user.username, {
                    organizationPath: null
                }),
                extraAttrs: {
                    ...USER_MENU_TRACKING_DEFAULTS,
                    'data-track-label': 'user_profile',
                    'data-testid': 'user-profile-link'
                }
            };
        }
    }
};
